import * as _ from 'lodash';
import * as React from 'react';
import { WrappedFieldInputProps } from 'redux-form';

import { generateInnerHtml } from '@blend/shared-react';
import ProductCard, { ProductCardConfig } from '../ProductCard/ProductCard';
import DetailsModal from '../DetailsModal/DetailsModal';

interface ProductCardGroupBase {
  name: string;
  input: WrappedFieldInputProps;
  configs: ProductCardConfig[];
}

interface ProductCardGroupProps extends ProductCardGroupBase {
  onSelect(value?: string): void;
  defaultSVG: React.ComponentType | null;
}

export interface ProductCardGroupConfig extends ProductCardGroupBase {
  value: any;
}

interface ProductCardGroupState {
  isModalOpen: boolean;
  modalTitle: string;
  modalContent: string;
  modalNotes: string[];
}

export default class ProductCardGroup extends React.Component<ProductCardGroupProps, ProductCardGroupState> {
  state: ProductCardGroupState = {
    isModalOpen: false,
    modalTitle: '',
    modalContent: '',
    modalNotes: [],
  };

  openModal(product: ProductCardConfig) {
    this.setState({
      isModalOpen: true,
      modalTitle: product.modalTitle,
      modalContent: product.modalContent,
      modalNotes: product.modalNotes,
    });
  }

  closeModal() {
    this.setState({ isModalOpen: false });
  }

  getProductCards() {
    const { input, configs, onSelect, defaultSVG } = this.props;
    return _.map(configs, productConfig => {
      return (
        <ProductCard
          key={productConfig.value}
          productId={productConfig.value}
          title={productConfig.title}
          description={productConfig.description}
          hasDetails={productConfig.hasDetails}
          isDisabled={productConfig.isDisabled}
          modalTitle={productConfig.modalTitle}
          modalContent={productConfig.modalContent}
          modalNotes={productConfig.modalNotes}
          imageLink={productConfig.imageLink}
          onSubmit={async () => {
            input.onChange(productConfig.value);
            // eslint-disable-next-line @typescript-eslint/await-thenable
            await onSelect(productConfig.value);
          }}
          openModal={() => this.openModal(productConfig)}
          defaultSVG={defaultSVG}
        />
      );
    });
  }

  getModal() {
    const { isModalOpen, modalTitle, modalContent, modalNotes } = this.state;
    return (
      <DetailsModal
        isOpen={isModalOpen}
        handleClose={() => this.closeModal()}
        title={modalTitle}
        footerNotes={modalNotes}
      >
        <div {...generateInnerHtml(modalContent)} />
      </DetailsModal>
    );
  }

  render() {
    const { configs } = this.props;
    // avoid render until products are populated
    if (_.isEmpty(configs)) return null;

    return (
      <div>
        {this.getProductCards()}
        {this.getModal()}
      </div>
    );
  }
}
